import courierRules from "@/constants/CourierRules";
import { courierDetail as _COURIERS_ } from "@/config/courierCodes";
import Vue from "vue";
const vm = new Vue();

export default class Temp {
  constructor(courierCode) {
    this.courierCode = courierCode;
  }
  _VUE = vm;
  listPostcodeSpecial = JSON.parse(localStorage.getItem("courier_postcode"));

  checkZone(postcode) {
    return null;
  }

  checkRemoteArea(postcode) {
    let remote_area_rate = 0;
    if (!this.listPostcodeSpecial.hasOwnProperty(this.courierCode)) {
      return remote_area_rate;
    }
    if (
      this.listPostcodeSpecial[this.courierCode].hasOwnProperty("remotearea")
    ) {
      Object.values(
        this.listPostcodeSpecial[this.courierCode].remotearea
      ).forEach((res, index) => {
        let zip = res.postcode.includes(postcode);
        if (zip == true) {
          return (remote_area_rate = res.cost);
        }
      });
    }
    return remote_area_rate;
  }

  checkRules(item, validate) {
    if (courierRules[this.courierCode]) {
      let checkDimension = true;
      let sizes = {
        width: Math.ceil(+item.size.width),
        length: Math.ceil(+item.size.length),
        height: Math.ceil(+item.size.height),
      };
      Object.keys(sizes).forEach((key) => {
        if (sizes[key] <= 0) {
          checkDimension = false;
          validate.dimension[key].status = false;
          validate.dimension[key].msg = "กรุณากรอกขนาดพัสดุ";
        } else if (sizes[key] > courierRules[this.courierCode].maxSize[key]) {
          checkDimension = false;
          validate.dimension[key].status = false;
          validate.dimension[key].msg =
            "ขนาดต้องไม่เกิน " +
            courierRules[this.courierCode].maxSize[key] +
            " ซม.";
        } else {
          validate.dimension[key].status = true;
          validate.dimension[key].msg = "";
        }
      });

      if (
        courierRules[this.courierCode].maxWLH &&
        sizes.width + sizes.length + sizes.height >
          courierRules[this.courierCode].maxWLH
      ) {
        checkDimension = false;
        validate.checkDimension.status = false;
        validate.checkDimension.msg =
          "ขนาดพัสดุรวมกันต้องไม่เกิน " +
          courierRules[this.courierCode].maxWLH +
          " ซม.";
      }

      if (checkDimension == false) {
        item.index = -1;
      }
      if (
        courierRules[this.courierCode].maxWeight &&
        item.weight > courierRules[this.courierCode].maxWeight
      ) {
        item.index = -1;
      }
    }

    return {
      index: item.index,
    };
  }

  checkCourierDimension(dimensionCourier, item, validate) {
    let sizes = {
      width: Math.ceil(+item.size.width),
      length: Math.ceil(+item.size.length),
      height: Math.ceil(+item.size.height),
    };
    let total = 0;
    let check = true;
    let index = -1;

    Object.keys(sizes).forEach((key) => {
      if (sizes[key] <= 0) {
        check = false;
        validate.dimension[key].status = false;
        validate.dimension[key].msg = "กรุณากรอกขนาดพัสดุ";
      } else {
        validate.dimension[key].status = true;
        validate.dimension[key].msg = "";
      }
    });
    if (check === true) {
      if (
        dimensionCourier[item.index].dimension == "" ||
        !dimensionCourier[item.index].dimension
      ) {
        let overSize = Object.values(sizes).filter((size) => {
          return size > courierRules[this.courierCode].maxSize;
        });
        if (overSize.length > 0) {
          check = false;
          validate.checkDimension.status = false;
          validate.checkDimension.msg =
            "ขนาดพัสดุด้านใดด้านหนึ่งต้องไม่เกิน " +
            courierRules[this.courierCode].overSize +
            " ซม.";
        } else if (
          sizes.width + sizes.length + sizes.height >
          courierRules[this.courierCode].maxWLH
        ) {
          check = false;
          validate.checkDimension.status = false;
          validate.checkDimension.msg =
            "ขนาดพัสดุรวมกันต้องไม่เกิน " +
            courierRules[this.courierCode].maxWLH +
            " ซม.";
        } else {
          total =
            ((sizes.width * sizes.length * sizes.height) /
              courierRules[this.courierCode].dimensionRatio) *
            1000;

          total = Math.round(total);
          if (total <= +dimensionCourier[item.index].max) {
            check = true;
            index = item.index;
            validate.checkDimension.status = true;
            validate.checkDimension.msg = "";
          } else {
            index = dimensionCourier.findIndex((rate) => {
              return total >= +rate.min && total <= +rate.max;
            });
            if (index < 0) {
              check = false;
              validate.checkDimension.status = false;
              validate.checkDimension.msg = "ขนาดพัสดุเกินกำหนด";
            }
          }
        }
      } else {
        total = Object.values(sizes).reduce((sum, num) => {
          return sum + Number(num);
        }, 0);
        if (total > +dimensionCourier[item.index].dimension) {
          index = dimensionCourier.findIndex((rate) => {
            return total <= +rate.dimension;
          });
          if (index < 0) {
            check = false;
            validate.checkDimension.status = false;
            validate.checkDimension.msg = "ขนาดพัสดุเกินกำหนด";
          }
        } else {
          check = true;
          index = item.index;
          validate.checkDimension.status = true;
          validate.checkDimension.msg = "";
        }
      }
    } else {
      check = false;
      validate.checkDimension.status = false;
      validate.checkDimension.msg = "ขนส่งนี้จำเป็นต้องระบุขนาดพัสดุ";
    }

    let res = {
      status: check,
      data: {
        index: index,
        dimension: total,
        ...sizes,
      },
    };

    return res;
  }

  addressCorrector(addressRemote) {
    let _SELF = vm;
    return new Promise((resolve) => {
      if (addressRemote.length < 3) {
        return resolve({ status: 0, data: [] });
      }
      _SELF.$http
        .post(
          _SELF.$API_URL + "/address-corrector",
          { address: addressRemote },
          { headers: { Token: localStorage.getItem("access_token") } }
        )
        .then((res) => {
          let data = res.data.data;
          if (!data) {
            resolve({ status: 0, data: [] });
          } else {
            resolve(data);
          }
        })
        .catch(() => {});
    });
  }

  getRemoteArea(addressRemote) {
    let _SELF = vm;
    return new Promise((resolve) => {
      if (addressRemote.length < 3) {
        return resolve({ status: 0, data: [] });
      }
      _SELF.$http
        .post(
          _SELF.$API_URL + "/remote/area",
          { address: addressRemote },
          { headers: { Token: localStorage.getItem("access_token") } }
        )
        .then((res) => {
          let data = res.data.data;
          if (!data) {
            resolve({ status: 0, data: [] });
          } else {
            resolve(data);
          }
        })
        .catch(() => {});
    });
  }
}
